import { render, staticRenderFns } from "./home-insurance-personal-form.html?vue&type=template&id=2dde570e&scoped=true&"
import script from "./home-insurance-personal-form.js?vue&type=script&lang=js&"
export * from "./home-insurance-personal-form.js?vue&type=script&lang=js&"
import style0 from "./home-insurance-personal-form.scss?vue&type=style&index=0&id=2dde570e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dde570e",
  null
  
)

export default component.exports